<template>
  <div class="view">
    <div class="title">群发服务通知</div>
    <div class="content">
      <div class="notice">
        <p>
          <i class="el-icon-info"></i>群发服务通知可以给自身小程序7日内所有活跃用户推送消息通知，从而进行活动推广和老用户唤醒, 为避免对用户产生骚扰，24小时之内只可对用户群发一次服务通知。（查看更多小贴士）
        </p>
      </div>
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="请输入消息名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"></el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="other_wrap">
          <el-button type="primary" @click="gonotificationadd">新建服务通知</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="消息名称" width="180"></el-table-column>
          <el-table-column prop="name" label="模板类型" width="180"></el-table-column>
          <el-table-column prop="address" label="点击人数/接收人数"></el-table-column>
          <el-table-column prop="address" label="点击率"></el-table-column>
          <el-table-column prop="address" label="发送时间"></el-table-column>
          <el-table-column label="运行状态">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.value" active-color="#2AA3F8" inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- @click="handleClick(scope.row)" -->
              <el-button type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination background layout="prev, pager, next" :total="50"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "notification",
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: []
    };
  },
  methods: {
    gonotificationadd() {
      this.$router.push({ name: "notificationAdd" });
    }
  }
};
</script>